import apiClient from './apiClient';

const API_URL = '/contactos';

// Obtener todos los contactos de un cliente por CUIL
export const getContactosPorCliente = async (cuil) => {
    const response = await apiClient.get(`${API_URL}/cliente/${cuil}`);
    return response.data;
};

// Crear un nuevo contacto
export const crearContacto = async (contacto) => {
    const response = await apiClient.post(API_URL, contacto);
    return response.data;
};

// Modificar un contacto existente
export const modificarContacto = async (id, contacto) => {
    const response = await apiClient.put(`${API_URL}/${id}`, contacto);
    return response.data;
};

// Eliminar un contacto por ID
export const eliminarContacto = async (id) => {
    const response = await apiClient.delete(`${API_URL}/${id}`);
    return response.data;
};
